module.exports = __webpack_public_path__ + "static/media/winter_discovery_pack_cat_EN.8c86e124.png";